<template>
  <BootstrapModal class="EditAccount"
    v-on="$listeners"

    @save="saveAccount"
  >
    <div class="d-xl-flex">
      <div class="container-element">
        <p>
          Laat het wachtwoordveld leeg als u het niet wilt bijwerken.
        </p>
        
        <div class="d-flex">
          <FormInput
            class="sm form-element"
            v-model="$v.name.$model"
    
            id="name"
            label="Naam"
    
            :vuelidate="$v"
            fieldName="name"
          />
          <FormInput
            class="sm form-element"
            v-model="$v.password.$model"
            
            id="password"
            label="Wachtwoord"
            type="password"
            
            :vuelidate="$v"
            fieldName="password"
          />
        </div>
        <FormInput
          class="form-element"
          v-model="$v.email.$model"
    
          id="email"
          label="Email"
    
          :vuelidate="$v"
          fieldName="email"
        />
        <div class="d-flex">
          <FormSelect v-model="status"
            class="sm form-element"
            id="account_status"
            label="Toestand"
    
            :options="activeOptions"
          />
          <FormSelect v-model="role"
            class="sm form-element"
            id="account_role"
            label="Rol"
    
            :options="roleOptions"
          />
        </div>
        <SelectedWebsites
          :selected="websites"
          @remove-website="removeWebsite"
        />
      </div>
      <div class="container-element d-flex">
        <SearchWebsites
          @select-website="selectWebsite"
          :selected="websites"
        />
      </div>
    </div>

    <template #title>
      {{ account ? "Bewerk account" : "Account toevoegen" }}
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"
import SearchWebsites from "./EditAccount/SearchWebsites.vue"
import SelectedWebsites from './EditAccount/SelectedWebsites.vue'
import FormSelect from "src/components/Inputs/FormSelect.vue"
import FormInput from "src/components/Inputs/FormInput.vue"

import { required, minLength, email } from "vuelidate/lib/validators"

import tableFieldOptions from "/src/mixins/tableFieldOptions"

export default {
  mixins: [tableFieldOptions],
  props: ["account", "callback"],
  components: {
    FormSelect,
    FormInput,
    SelectedWebsites,
    SearchWebsites,
    BootstrapModal,
  },
  data() {
    return {
      websites: [],
      status: null,
      role: null,
      name: "",
      email: "",
      password: "",
    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(3),
    },
    email: {
      required,
      email,
    },
    password: {},
  },
  created() {
    const account = this.account
    if (account) {
      this.websites = account.websites.map(item => ({...item, uid: item.external_id}))

      this.$v.name.$model = account.name
      this.$v.password.$model = account.password
      this.$v.email.$model = account.email
      this.role = account.role
      this.status = account.status
    }
  },
  methods: {
    selectWebsite(site) {
      this.websites.push(site)
    },
    removeWebsite(uid) {
      this.websites.splice(
        this.websites.findIndex(item => item.uid === uid),
        1
      )
    },
    
    async saveAccount() {
      this.$v.$touch()
      if (this.$v.$error) return;

      const payload = {
        name: this.$v.name.$model,
        password: this.$v.password.$model,
        status: this.status,
        role: this.role,
        websites: this.websites.map(item => item.uid),
        email: this.email,
      }

      this.$handlePromise(async () => {
        let message = 'Website succesvol toegevoegd!'
        if (!this.account) {
          await this.axios.post("/api/accounts", payload)
        } else {
          
          if (!payload.password) {
            delete payload.password
          }

          message = 'Website aangepast!'
          await this.axios.put(`/api/accounts/${this.account.uid}`, payload)
        }

        this.$success(message)
        this.callback && this.callback()
        this.$emit("close")
      })
    },
  },
}

</script>

<style scoped src="@/assets/css/form.css"></style>

<style scoped>

.EditAccount {
  flex-basis: 950px;
}

.container-element {
  flex-basis: 100%;
  min-height: 300px;
}

.container-element + .container-element {
  margin-top: 22px;
}

@media (min-width: 1200px) {
  .container-element + .container-element {
    margin-left: 28px;
    min-height: unset;
    margin-top: 0px;
  }
}

</style>
